/** @format */
import LoadingStyle from "./LoadingStyle.module.scss";

const Loading = () => {
    return (
        <div className={LoadingStyle['lds-spinner']}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};
export default Loading;
